/**
 * @generated SignedSource<<69ad7784aa918ee26ba632ff8b005c5c>>
 * @relayHash 562d114c240fd69a4b9acb2f4bf91dce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7bebf7ed0fb51b53b001d0d0dceda45aedde9a5daf177fb699b5107836074469

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SavedTabsAggRootQuery$variables = {
  containerId: string;
  viewId: string;
};
export type SavedTabsAggRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SavedTabsAggData">;
};
export type SavedTabsAggRootQuery = {
  response: SavedTabsAggRootQuery$data;
  variables: SavedTabsAggRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "viewId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v2 = {
  "alias": "uuid",
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SavedTabsAggRootQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SavedTabsAggData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SavedTabsAggRootQuery",
    "selections": [
      {
        "alias": "goalsDirectoryViews",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 200
          },
          {
            "kind": "Literal",
            "name": "sort",
            "value": [
              "FAVOURITED_DATE_DESC"
            ]
          }
        ],
        "concreteType": "TownsquareDirectoryViewConnection",
        "kind": "LinkedField",
        "name": "goals_directoryViewSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareDirectoryViewEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TownsquareDirectoryView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "goalsView",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "directoryId",
            "variableName": "viewId"
          }
        ],
        "concreteType": "TownsquareDirectoryView",
        "kind": "LinkedField",
        "name": "goals_directoryViewById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "7bebf7ed0fb51b53b001d0d0dceda45aedde9a5daf177fb699b5107836074469",
    "metadata": {},
    "name": "SavedTabsAggRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "97b95118b44f86dd59fc12986255904c";

export default node;
